import PaymentsPopup from '../Payments/PaymentsPopup';
import { getString } from '../../../strings';
import { StyledText } from '../../atoms/Text/StyledText';
import { StyledButton } from '../../atoms/Button/StyledButton';
import { useNavigate } from 'react-router-dom';
import { sessionService } from 'redux-react-session';

const SessionExpiredPopup = ({ onClose }) => {
    const navigate = useNavigate();

    const goToLogin = async () => {
        await sessionService.deleteUser();
        navigate("/login");
        onClose();
    };

    return (
        <PaymentsPopup>
            <>
                <StyledText
                    hasdeclaredfontweight="700"
                    hasdeclaredfontsize="24px"
                    hasdeclaredpadding={'40px 20px 20px 20px'}
                    hasdeclaredlineheight="1.4em"
                    hasdeclaredtextalign="center"
                >
                    {getString('session_expired_modal_title')}
                </StyledText>
                <StyledText
                    hasdeclaredfontsize="18px"
                    hasdeclaredlineheight="1.4em"
                    hasdeclaredtextalign="center"
                >
                    {getString('session_expired_modal_message')}
                </StyledText>
                <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
                    <StyledButton
                        hasdeclaredfontcolor="#fff"
                        hasdeclaredbgcolor="#6d85ba"
                        hasdeclaredtextalign="center"
                        hasdeclaredcursor="pointer"
                        hasdeclaredwidth="150px"
                        hasdeclaredheight="50px"
                        hasdeclaredfontsize="20px"
                        hasdeclaredborderradius="35px"
                        hasdeclaredmargin="20px 0 30px 0"
                        hasdeclaredfontweight="600"
                        whileTap={{ scale: 0.9 }}
                        whileHover={{ scale: 1.05 }}
                        hasdeclaredtexttransform="uppercase"
                        onClick={goToLogin}
                    >
                        {getString('session_expired_button')}
                    </StyledButton>
                </div>
            </>
        </PaymentsPopup>
    );
};

export default SessionExpiredPopup;
